import React from 'react';
import cn from 'classnames';
import type { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Image from 'tbk-components/src/components/Image';
import { ILink } from 'tbk-components/src/components/Button';
import SearchTool from '../SearchTool';
import { bgColors, colorMap } from '../../utils';

import logoText from '../../assets/logo-text.svg';

export interface ICtaSearchProps extends IBaseElementProps {
	backgroundColor?: bgColors;
	searchUrl?: ILink;
}

/**
 * Call To Action search bar
 * @icon interactive
 * @block
 * @requiresHooks
 */

const CtaSearch: React.FC<ICtaSearchProps> = ({
	backgroundColor = 'yellow',
	searchUrl,
}) => (
	<div
		className={cn(
			'cta-search',
			`cta-search--bg-${colorMap[backgroundColor]}`,
		)}
	>
		<div className="cta-search__inner">
			<Image src={logoText} width={212} height={100} />
			<SearchTool url={searchUrl ? searchUrl.href : ''} />
		</div>
	</div>
);

export default CtaSearch;
